import React, { useContext } from "react";
import { defineMessages, useIntl } from "react-intl";

import {
  useTokenizedLinkSignup,
  usePreBillHeapEvent,
} from "@app/preBill/hooks";
import StepperHeaderProgress from "@app/components/stepperHeaderProgress";
import { SuccessInfoBox } from "@app/preBill/components/successInfoBox";
import { AccountInfoBox } from "@app/preBill/components/accountInfoBox";
import { FAQInfoText } from "@app/preBill/components/faqInfoText";
import { SurveySection } from "@app/preBill/components/surveySection";
import { UserContext } from "@app/provider";
import { HEAP_EVENTS } from "@app/provider/types";

import "./ncsPaymentConclusion.scss";

const messages = defineMessages({
  ncsPaymentConclusionTitle: {
    id: "ncsPaymentConclusionTitle",
    defaultMessage: "Thank you for your payment!",
  },
  ncsPaymentConclusionDescription: {
    id: "ncsPaymentConclusionDescription",
    defaultMessage:
      "We’ve received your payment. You’ll receive a confirmation email shortly.",
  },
});

const NcsPaymentConclusion: React.FC = () => {
  const intl = useIntl();
  const { uppUser } = useContext(UserContext);
  const { redirectToTokenizedSignup, isLoading } = useTokenizedLinkSignup();
  const { trackPreBillHeapEvent } = usePreBillHeapEvent();

  const handleClickCreateAccount = async (): Promise<void> => {
    trackPreBillHeapEvent({
      eventKey: HEAP_EVENTS.upp_pb_click_create_account,
    });
    redirectToTokenizedSignup();
  };

  return (
    <>
      <StepperHeaderProgress />
      <div className="ncs-payment-conclusion">
        <SuccessInfoBox
          title={intl.formatMessage(messages.ncsPaymentConclusionTitle)}
          description={intl.formatMessage(
            messages.ncsPaymentConclusionDescription
          )}
        />
        <SurveySection />
        {!uppUser && (
          <AccountInfoBox
            createAccountButtonAction={handleClickCreateAccount}
            isLoading={isLoading}
          />
        )}
        <FAQInfoText />
      </div>
    </>
  );
};

export default NcsPaymentConclusion;
